// import components
import { Menu } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';

// import external libraries
import { useTranslation } from 'react-i18next';

// import types
import { MenuItemsProps } from './MenuItems.types';

// Base element for Subheaders menu items
export const MenuItems: React.FC<MenuItemsProps> = ({
  handleClose,
  tabulatedItems,
  anchorEl,
  setTabbedElement,
  open,
  page,
  disableRouting = false,
  showCustomMenuItemLabel = false
}) => {
  const { t } = useTranslation('common');

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
      >
        {tabulatedItems.map((currentTab, i) => (
          <MenuItem
            color="neutral"
            key={i}
            onClick={(e) => {
              if (disableRouting) e.preventDefault();
              handleClose();
              setTabbedElement(currentTab);
            }}
            {...(!disableRouting && page
              ? {
                  component: 'a',
                  href: `/#${page}&page=${currentTab.name.toLowerCase()}`
                }
              : {})}
          >
            {showCustomMenuItemLabel
              ? t(`${currentTab.label}`)
              : t(`tableTabs.${currentTab.name}`)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
